module.exports = __webpack_public_path__ + "media/img/home/animate/mobile/item2-415952490df775f1aef5cdff090f2f98.svg";